import { Children } from 'react'

const Conditional = ({ children, condition = false }) => {
  if (children && condition) {
    if (typeof children === 'function') {
      return children()
    }
    return Children.only(children)
  }
  return null
}
Conditional.displayName = 'Kuiper: Conditional'

export default Conditional
